import React from 'react';
import PropTypes from 'prop-types';

import VerifiedUserIcon from '@mui/icons-material/VerifiedUser';
import VerifiedUserOutlinedIcon from '@mui/icons-material/VerifiedUserOutlined';
import Tooltip from '@mui/material/Tooltip';
import { grey, green } from '@mui/material/colors';
import {styled} from '@mui/system';


const verifiedOptions = [
    {key: true, label: 'This document is verified'},
    {key: false, label: 'This document is not verified'},
];


const StyledTooltip = styled(Tooltip)(({ theme }) =>({
    fontSize: theme.custom.font.small
}));

const StyledVerifiedUserIcon = styled(VerifiedUserIcon)({
    color: green[500],
    height: 20,
    width: 20
});

const StyledVerifiedUserOutlinedIcon = styled(VerifiedUserOutlinedIcon)({
    color: grey[500],
    height: 20,
    width: 20
});


class DocumentVerifiedStatus extends React.Component {

    constructor(props) {
        super(props);
    }

    get_item = () => {
        if(this.props.verified) {
            return <StyledVerifiedUserIcon />;
        }
        return <StyledVerifiedUserOutlinedIcon />;
    };

    render() {
        let label = '';
        verifiedOptions.forEach((status) => {
            if (this.props.verified === status['key']){
                label = status['label'];
            }
        });

        return (
            <StyledTooltip title={label} placement="right">
                {this.get_item()}
            </StyledTooltip>
        );
    }
}


DocumentVerifiedStatus.propTypes = {
    verified: PropTypes.bool
};

export default DocumentVerifiedStatus;
